import React from "react";
import { Box, Card, Typography, makeStyles, Chip } from "@material-ui/core";
import {
  LegalPersonType,
  TimeReportStatus,
  useTimeReportKit_GetKitQuery
} from "@graphql";
import { Spinner } from "@common";
import { OpenInNew } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { KIT_SLIDER, KitProfileLocation } from "@navigation";
import { useNavManager } from "@hooks";
import moment from "moment";
import {
  getRowColor,
  rowClasses
} from "../../../../booking-kits/components/kits-table/booking-kit-table";

export type Props = {
  bookingId: string;
  status: TimeReportStatus;
  week: number;
  legalPersonType: LegalPersonType;
};

export const KitListByBooking = (props: Props) => {
  const nav = useNavManager();

  const { data, loading } = useTimeReportKit_GetKitQuery({
    variables: {
      bookingId: props.bookingId
    },
    fetchPolicy: "network-only"
  });

  const classes = useStyles({});

  if (loading) {
    return <Spinner show />;
  }
  return (
    <Box className={classes.wrapper}>
      {data?.bookingKits.length === 0 && (
        <Typography variant={"subtitle1"} align={"center"}>
          {locale.NoItems}
        </Typography>
      )}
      {data?.bookingKits?.map((kit) => (
        <Card
          className={`${classes.item} ${classes[getRowColor(kit.lastStatusType)]}`}
          key={kit._id}
          elevation={1}
          square
          onClick={() => {
            nav.navManager.open(KIT_SLIDER, new KitProfileLocation(kit._id));
          }}
        >
          <div className={classes.titleWrap}>
            <Typography variant={"subtitle1"}>
              {kit.name} - {locale.Type}:{" "}
              <strong>{locale.bookingKitType[kit.type]}</strong>
            </Typography>
            <OpenInNew color={"primary"} />
          </div>
          <Typography variant={"subtitle1"}>
            {locale.Status}:{" "}
            <Chip
              className={classes[getRowColor(kit.lastStatusType)]}
              label={locale.bookingKitStatusType[kit.lastStatusType]}
            />
          </Typography>
          <Typography>
            Skapad: {kit.createdOn && moment(kit.createdOn).format("YYYY-MM-DD HH:mm")}
          </Typography>
        </Card>
      ))}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    padding: theme.spacing(2),
    gap: theme.spacing(1),
    flexDirection: "column"
  },
  item: {
    padding: theme.spacing(2),
    maxWidth: "50%",
    cursor: "pointer",
    display: "flex",
    gap: theme.spacing(1),
    flexDirection: "column",
    "&:hover": {
      backgroundColor: theme.palette.grey[200]
    }
  },
  titleWrap: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  ...rowClasses(theme)
}));
